import axios from "axios";
import {useContext} from "react";
import AuthContext from "../Store/auth-context";

const RoleChange =async (data,customerEmail)=>{
    const {setRoleStatus} = useContext(AuthContext);
    await axios.post("https://stripe-node-vx6pg.ondigitalocean.app/RoleChange",{roleState:data,customerEmail:customerEmail})
    // await axios.post("http://aad3-66-154-104-9.ngrok.io/RoleChange",{roleState:data,customerEmail:customerEmail})
        .then(res=>{
            setRoleStatus(res.data.data[0].is_active);
        })
}

export default RoleChange;
